module.exports = __webpack_public_path__ + "img/ic_medium.37455922.svg";